import TiktokThumbnail from "@/components/TiktokThumbnail";
import { useEpisode } from "@/containers/Episode/context";
import Clickable from "@components/Clickable";

const TiktokCover = ({ episode }) => {
  const { setMediaModalOpen } = useEpisode();

  if (!episode.episode_guid) {
    return <TiktokThumbnail size="lg" />;
  }

  return (
    <Clickable
      data-testid="tiktok-embed-open"
      onClick={() => setMediaModalOpen(true)}
    >
      <TiktokThumbnail className="size-full" size="lg" />
    </Clickable>
  );
};
export default TiktokCover;
